/*
const initialValues = {
  business_activities_region_state: 'New México',
  business_activities_list_ports: [],
  business_activities_cities_visited: [],
  business_activities_type_business_company: []
};
const validationSchema = Yup.object({
  business_activities_region_state: Yup.string().required('Required'),
  business_activities_list_ports: Yup.array().of(Yup.string()),
  business_activities_cities_visited: Yup.array().of(Yup.string()),
  business_activities_type_business_company: Yup.array().of(Yup.string())
});

*/
import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from "yup";
//import clearValue from react select
import ReactSelect, { components } from 'react-select';
import Select from 'react-select'

const BfFormstep12 = ({ lang, setLang,  nextStep, backStep, updateFormData, formData }) => {
 //useeffect print formdata
  useEffect(() => {
    console.log('formData:', formData);
  }, [formData]);
  
  const busOptions = [
    { value: "COACH / MOTOR COACH", label: "COACH / MOTOR COACH", labelEsp: "AUTOBÚS / AUTOCAR" },
    { value: "DOUBLE DECKER", label: "DOUBLE DECKER", labelEsp: "DE DOS PISOS" },
    { value: "HYBRID BUS", label: "HYBRID BUS", labelEsp: "AUTOBÚS HÍBRIDO" },
    { value: "LOW FLOOR BUS", label: "LOW FLOOR BUS", labelEsp: "AUTOBÚS DE PISO BAJO" },
    { value: "MINIBUS", label: "MINIBUS", labelEsp: "MINIBÚS" },
    { value: "MINICOACH", label: "MINICOACH", labelEsp: "MINICOACH" },
    { value: "NEIGHBORHOOD BUS", label: "NEIGHBORHOOD BUS", labelEsp: "AUTOBÚS DE VECINDARIO" },
    { value: "SHUTTLE BUS", label: "SHUTTLE BUS", labelEsp: "AUTOBÚS DE ENLACE" },
    { value: "SINGLE DECKER", label: "SINGLE DECKER", labelEsp: "AUTOBÚS DE UN SOLO PISO" },
    { value: "STEP ENTRANCE BUS / HIGH FLOOR", label: "STEP ENTRANCE BUS / HIGH FLOOR", labelEsp: "AUTOBÚS DE ENTRADA POR ESCALONES / PISO ALTO" },
  ];
  
  const busOptionsSpanish = [
    { value: "COACH / MOTOR COACH", label: "AUTOBUS DE DOS PISOS" },
    { value: "DOUBLE DECKER", label: "AUTOBUS DE DOS PISOS" },
    { value: "HYBRID BUS", label: "AUTOBUS HIBRIDO" },
    { value: "LOW FLOOR BUS", label: "AUTOBUS DE PISO BAJO" },
    { value: "MINIBUS", label: "MINIBUS" },
    { value: "MINICOACH", label: "MINICOACH" },
    { value: "NEIGHBORHOOD BUS", label: "AUTOBUS DE VECINDARIO" },
    { value: "SHUTTLE BUS", label: "AUTOBUS DE TRANSPORTE" },
    { value: "SINGLE DECKER", label: "AUTOBUS DE UN SOLO PISO" },
    { value: "STEP ENTRANCE BUS / HIGH FLOOR", label: "AUTOBUS DE PISO ALTO" },
  ];
  const portOptions = [
    { value: "AZ - DOUGLAS (RAUL HECTOR CASTRO)", label: "AZ - DOUGLAS (RAUL HECTOR CASTRO)" },
    { value: "AZ - LUKEVILLE", label: "AZ - LUKEVILLE" },
    { value: "AZ - NACO", label: "AZ - NACO" },
    { value: "AZ - NOGALES - MARIPOSA", label: "AZ - NOGALES - MARIPOSA" },
    { value: "CA - ANDRADE", label: "CA - ANDRADE" },
    { value: "CA - CALEXICO - EAST", label: "CA - CALEXICO - EAST" },
    { value: "CA - OTAY MESA - COMMERCIAL", label: "CA - OTAY MESA - COMMERCIAL" },
    { value: "CA - TECATE (TEC)", label: "CA - TECATE (TEC)" },
    { value: "NM - COLUMBUS", label: "NM - COLUMBUS" },
    { value: "NM - SANTA TERESA - SANTA TERESA PORT OF ENTRY", label: "NM - SANTA TERESA - SANTA TERESA PORT OF ENTRY" },
    { value: "TX - BROWNSVILLE - LOS INDIOS", label: "TX - BROWNSVILLE - LOS INDIOS" },
    { value: "TX - BROWNSVILLE - VETERANS INTERNATIONAL", label: "TX - BROWNSVILLE - VETERANS INTERNATIONAL" },
    { value: "TX - DEL RIO", label: "TX - DEL RIO" },
    { value: "TX - EAGLE PASS - BRIDGE II", label: "TX - EAGLE PASS - BRIDGE II" },
    { value: "TX - EL PASO - BRIDGE OF THE AMERICAS (BOTA)", label: "TX - EL PASO - BRIDGE OF THE AMERICAS (BOTA)" },
    { value: "TX - EL PASO - YSLETA", label: "TX - EL PASO - YSLETA" },
    { value: "TX - FABENS - TORNILLO", label: "TX - FABENS - TORNILLO" },
    { value: "TX - HIDALGO/PHARR - PHARR", label: "TX - HIDALGO/PHARR - PHARR" },
    { value: "TX - LAREDO - COLUMBIA SOLIDARITY", label: "TX - LAREDO - COLUMBIA SOLIDARITY" },
    { value: "TX - LAREDO - WORLD TRADE BRIDGE", label: "TX - LAREDO - WORLD TRADE BRIDGE" },
    { value: "TX - PRESIDIO", label: "TX - PRESIDIO" },
    { value: "TX - PROGRESO - PROGRESO INTERNATIONAL BRIDGE", label: "TX - PROGRESO - PROGRESO INTERNATIONAL BRIDGE" },
    { value: "TX - RIO GRANDE CITY", label: "TX - RIO GRANDE CITY" },
    { value: "TX - ROMA", label: "TX - ROMA" },
    { value: "TX - ROMA TEXAS - ROMA TEXAS", label: "TX - ROMA TEXAS - ROMA TEXAS" },
];

  const [availablePortOptions, setAvailablePortOptions] = useState([]);


  const [availableBusOptions, setAvailableBusOptions] = useState(
   // lang === 'eng' ? busOptions : busOptionsSpanish
   busOptions
  );

  
  useEffect(() => { setAvailablePortOptions(portOptions); }, []);
  useEffect(() => { setAvailableBusOptions(busOptions); }, []);
  const getFirstErrorKey = (object, keys = []) => {
    const isObject = (value) => {
      return value != null && typeof value === 'object' && !Array.isArray(value);
    };
    
    const firstErrorKey = Object.keys(object)[0];
    if (isObject(object[firstErrorKey])) {
      return getFirstErrorKey(object[firstErrorKey], [...keys, firstErrorKey]);
    }
    return [...keys, firstErrorKey].join(".");
  };

  function handleOnlyLettersInputChange(e) {
    // Extract the input value
    const inputValue = e.target.value;

    // Filter out non-letter characters
    const lettersOnlyValue = inputValue.replace(/[^a-zA-Z ]/g, '');

    // Update the input's value with the filtered value
    e.target.value = lettersOnlyValue;
  }

  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const [selectedBusValue, setSelectedBusValue] = useState(null); //bus
  const [selectedValue, setSelectedValue] = useState(null);
  const [citiesItems, setcitiesItems] = useState([]);
  const [portItems, setportItems] = useState([]);
  const [busItems, setbusItems] = useState([]);
  useEffect(() => {
    // Map cities
    
    const citiesMapped = Array.isArray(formData.business_activities_cities_visited)
      ? formData.business_activities_cities_visited.map((city, index) => ({
        id: String(index + 1), // Create an ID based on the index (1-based)
        text: city,
      }))
      : [];
    setcitiesItems(citiesMapped);

    // Map ports
    const portsMapped = Array.isArray(formData.business_activities_list_ports)
      ? formData.business_activities_list_ports.map((port, index) => ({
        id: String(index + 1), // Create an ID based on the index (1-based)
        text: port,
      }))
      : [];
    setportItems(portsMapped);

   // Map business items
const busItemsMapped = Array.isArray(formData.business_activities_type_business_company)
? formData.business_activities_type_business_company.map((busItem, index) => {
    // Find the corresponding bus option
    const busOption = busOptions.find(option => option.value === busItem);

    return {
      id: String(index + 1), // Create an ID based on the index (1-based)
      text: busItem,
      textSpa: busOption ? busOption.labelEsp : busItem,
    };
  })
: [];
setbusItems(busItemsMapped);
  }, [formData]);
  ;
  const messages = {
    min: lang === 'eng' ? "Please enter at least 2 characters" : "Por favor, ingrese al menos 2 caracteres",
    required: lang === 'eng' ? "This field is required" : "Este campo es obligatorio",
    email: lang === 'eng' ? "Please enter a valid email address" : "Por favor, ingrese una dirección de correo electrónico válida",
    phone: lang === 'eng' ? 'Please enter 10 digits' : 'Por favor, ingrese 10 dígitos',
    moreThan: lang === 'eng' ? "Please select an option" : "Por favor, seleccione una opción"
  };

  //useeffect busitems is not empty, setisbuttonclicked to true
  useEffect(() => {
    if (busItems.length != 0) {
      setIsButtonClicked(true);
    }
  }, [busItems]);

  const checkifBusItems = () => {
    if (busItems.length === 0) {
      setIsButtonClicked(true);
    }
    if (isButtonClicked && busItems.length != 0){
      return true;
    }
    else {
      return false;
    }

  }

  const formik = useFormik({
    initialValues: {
      business_activities_region_state: formData.business_activities_region_state || '',
      business_activities_list_ports: [],
      business_activities_cities_visited: [],
      business_activities_type_business_company: []
    },
    validationSchema :Yup.object().shape({
      business_activities_region_state: Yup.string().required(messages.required),
    }),

    onSubmit: (values) => {
  


      //onsubmit, port entries, business_activities_cities_visited and business_activities_type_business_company have to be populated with the id from the values of the business_activities_region_state variables
      //selectedPortItems = a loop that goes through the values of the business_activities_region_state variable and returns the text of the port

      const selectedPortItems = portItems.map(item => item.text);
      const selectedCitiesItems = citiesItems.map(item => item.text);
      const selectedTypeBusinessCompanyItems = busItems.map(item => item.text);



      values.business_activities_list_ports = selectedPortItems;
      values.business_activities_cities_visited = selectedCitiesItems;
      values.business_activities_type_business_company = selectedTypeBusinessCompanyItems;

     
      updateFormData(values);
      nextStep();
    },
  });
  const handleSelfRemove = (itemId) => {
    const removedPort = portItems.find(item => item.id === itemId);
    const updatedportItems = portItems.filter((item) => item.id !== itemId);
    setportItems(updatedportItems);

    if (removedPort) {
        const newAvailablePortOption = { value: removedPort.text, label: removedPort.text };
        setAvailablePortOptions(prevOptions => {
            const updatedOptions = [...prevOptions, newAvailablePortOption];
            return updatedOptions.sort((a, b) => a.label.localeCompare(b.label));
        });
    }
};



  const [showPortsDropDown, setshowPortsDropDown] = useState(false);


  const [portItemIdCounter, setportItemIdCounter] = useState(1); // Initialize with the next available ID (e.g., 3)


  const handlePortSelection = (name) => {
    setshowPortsDropDown(false);
    setportItems([...portItems, { id: portItemIdCounter, text: name }]);
    setportItemIdCounter(portItemIdCounter + 1);
    setSelectedValue(null);
    setAvailablePortOptions(prevOptions => prevOptions.filter(option => option.label !== name));
  };
  


  //create showdropdown, items, itemidcounter and handleselection for cities visited and bus company type
  const [showcitiesDropDown, setshowcitiesDropDown] = useState(false);

  const [citiesItemIdCounter, setcitiesItemIdCounter] = useState(1); // Initialize with the next available ID (e.g., 3)
  const handleCitiesSelection = (name) => {
    setshowcitiesDropDown(false);
    // Add the new item to the list of portItems, the prop is the text of the option  
    setcitiesItems([...citiesItems, { id: citiesItemIdCounter, text: name }]);
    // Increment the counter to get the next ID
    setcitiesItemIdCounter(citiesItemIdCounter + 1);
  };
  const handleCitiesRemove = (itemId) => {
    const updatedcitiesItems = citiesItems.filter((item) => item.id !== itemId);
    setcitiesItems(updatedcitiesItems);
  };

  //bus
  const [showBusDropDown, setshowBusDropDown] = useState(false);

  const [busItemIdCounter, setbusItemIdCounter] = useState(1); // Initialize with the next available ID (e.g., 3)
  const handleBusSelection = (name) => {
    setshowBusDropDown(false);
  
    const selectedItem = busOptions.find(option => option.value === name);
    const selectedItemLabel = selectedItem?.label;
    const selectedItemLabelSpa = selectedItem?.labelEsp; // Assuming you added labelEsp for Spanish
  
    setbusItems([...busItems, { id: busItemIdCounter, text: selectedItemLabel, textSpa: selectedItemLabelSpa }]);
    setbusItemIdCounter(busItemIdCounter + 1);
    setSelectedBusValue(null);
  
    setAvailableBusOptions(prevOptions => prevOptions.filter(option => option.value !== name));
  };
  

  const handleBusRemove = (itemId) => {
    const removedBus = busItems.find(item => item.id === itemId);
    const updatedbusItems = busItems.filter((item) => item.id !== itemId);
    setbusItems(updatedbusItems);
  
    if (removedBus) {
      const newAvailableBusOption = {
        value: removedBus.text,
        label: lang === 'eng' ? removedBus.text : removedBus.textSpa,
      };
  
      setAvailableBusOptions(prevOptions => {
        const updatedOptions = [...prevOptions, newAvailableBusOption];
        return updatedOptions.sort((a, b) => a.label.localeCompare(b.label));
      });
    }
  };
  

  const [isEditing, setIsEditing] = useState(false);
  const selectRef = useRef(null);
  useEffect(() => {
    if (!formik.isValid && formik.submitCount !== 0 && formik.isSubmitting) {
      const firstErrorKey = getFirstErrorKey(formik.errors);
      if (global.window.document.getElementsByName(firstErrorKey).length) {
        global.window.document.getElementsByName(firstErrorKey)[0].focus();
      }
    }
  }, [formik.submitCount, formik.isValid, formik.errors, formik.isSubmitting]);

  useEffect(() => {
    if (isEditing && selectRef.current) {
        selectRef.current.focus();
    }
}, [isEditing]);

const [isCitiesEditing, setIsCitiesEditing] = useState(false);
const cityNameRef = useRef(null); // Reference for the input

useEffect(() => {
    if (isCitiesEditing && cityNameRef.current) {
        cityNameRef.current.focus();
    }
}, [isCitiesEditing]);

const [isBusEditing, setIsBusEditing] = useState(false);
const busSelectRef = useRef(null); // Reference for the dropdown

useEffect(() => {
    if (isBusEditing && busSelectRef.current) {
        busSelectRef.current.focus();
    }
}, [isBusEditing]);


const selectStyles = {

  option: (base, state) => ({
    ...base,
    color: '#333',
    backgroundColor: state.isFocused ? '#E5F6FF': '#fff',
    fontSize: 14,
  }),
  control: (base) => ({
    ...base,
    border: 0,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    cursor: 'text'
  }),
  menu: (base) => ({
    ...base,
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
    borderRadius: '0 0 8px 8px',
    maxWidth: 280,
    zIndex: 100
  }),
  placeholder: (base) => ({
    ...base,
    color: '#1479CA',
  }),
  singleValue: (base) => ({
    ...base,
    color: 'black',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    display: 'none'
  }),
  // Assuming you want to integrate the scrollbar styles into the menu
  menuList: (base) => ({
    ...base,
    '&::-webkit-scrollbar': {
      height: '5px',
      width: '7px'
    },
    '&::-webkit-scrollbar-track': {
      background: '#E8F8FF',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CDDFEB',
      borderRadius: '8px'
    }
  }),
}




  return (

    <>
      <header className="c-site-header">
        <a className="c-site-header__skip js-site-header-skip" href="#main">
          Skip to main content
        </a>
        <div className="o-wrapper">
          <a
            className="c-site-header__logo-link"
            href="./"
            aria-label="Go to home page"
          >
            <img
              className="c-site-header__logo"
              src="images/components/site-header/logo-blf-specialty.svg"
              alt="Bluefire Specialty Logo"
              width={100}
              height={34}
            />
          </a>
          <h1 className="c-site-header__title">
            <span className="o-icon">
              <svg aria-hidden="true" focusable="false" role="img">
                <use href="images/icons/icons.svg#icon-form" />
              </svg>
            </span>
            {lang === 'eng' ? 'Quote Application for Buses Insurance' : 'Solicitud de cotización para seguro de autobuses'}

          </h1>
          <div className="c-site-header__controls c-header-controls">
  <button 
    className="c-header-controls__language" 
    onClick={() => setLang(lang === 'eng' ? 'spa' : 'eng')}  // Toggle the language
  >
    <span className="o-icon c-header-controls__icon">
      <svg aria-hidden="true" focusable="false" role="img">
        <use href="images/icons/icons.svg#icon-language" />
      </svg>
    </span>
    <span className="u-hidden-visually">
      {lang === 'eng' ? 'Switch to Spanish' : 'Switch to English'}
    </span>
    <span className="c-header-controls__text">
      {lang === 'eng' ? 'Español' : 'English'}
    </span>
  </button>
</div>
        </div>
      </header>
      <main className="c-main-content">
        <div className="c-section">
          <div className="o-wrapper o-wrapper--small">
            <h1 className="c-section__title">
              <span className="o-icon">
                <svg aria-hidden="true" focusable="false" role="img">
                  <use href="images/icons/icons.svg#icon-form" />
                </svg>
              </span>
              {lang === 'eng' ? 'Quote Application for Buses Insurance' : 'Solicitud de cotización para seguro de autobuses'}

            </h1>
            <div className="c-section__content">
              <div className="c-steps">
                <ul className="o-list-bare c-steps__list">
                  <li className="o-list-bare__item c-steps__item c-steps__item--50 c-steps__step--active">
                    <div className="c-steps__step">
                    <div className="c-steps__text">{lang === 'eng' ? 'Applicant' : 'Solicitante'}</div>
                      <div className="c-steps__circle" />
                    </div>
                  </li>
                  <li className="o-list-bare__item c-steps__item">
                    <div className="c-steps__step c-steps__step">
                    <div className="c-steps__text">{lang === 'eng' ? 'Drivers' : 'Conductores'} </div>
                      <div className="c-steps__circle" />
                    </div>
                  </li>
                  <li className="o-list-bare__item c-steps__item">
                    <div className="c-steps__step c-steps__step">
                    <div className="c-steps__text">{lang === 'eng' ? 'Vehicles' : 'Vehículos'}</div>
                      <div className="c-steps__circle" />
                    </div>
                  </li>
                  <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Documents' : 'Documentos' }</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
                  <li className="o-list-bare__item c-steps__item">
                    <div className="c-steps__step">
                    <div className="c-steps__text">{lang === 'eng' ? 'Finish' : 'Finalizar' }</div>
                      <div className="c-steps__circle" />
                    </div>
                  </li>
                </ul>
              </div>
              <div className="c-content">
                <div className="c-quote">
                  <form onSubmit={formik.handleSubmit} className="c-quote__form js-form" noValidate>
                    <h2 className="c-quote__title">
                      {lang === 'eng' ? 'Detailed Description of Business Activities' : 'Descripción detallada de las actividades comerciales'}
                    </h2>
                    <div className="c-quote__item">
                    <label className="c-quote__label" htmlFor="">
                        {lang === 'eng' ? 'Please specify the DOT-registered state' : 'Seleccione el estado registrado en DOT'}
                        </label>
                      {/* business_activities_region_state */}
                      <select
                        className={"c-quote__select c-quote__select--50"}
                        id="business_activities_region_state"
                        name="business_activities_region_state"
                        required
                        aria-required="true"
                        aria-invalid={formik.touched.business_activities_region_state && formik.errors.business_activities_region_state ? 'true' : 'false'}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.business_activities_region_state}
                      >
                        <option value="" disabled>
                          {lang === 'eng' ? 'State' : 'Estado'}
                        </option>
                       
                        <option value="AZ">Arizona</option>
                     
                        <option value="CA">California</option>
                    
               
                        <option value="NM">New Mexico</option>
             
                        <option value="TX">Texas</option>
               
                      </select>
                      {formik.touched.business_activities_region_state && formik.errors.business_activities_region_state ? (
                        <label id="business_activities_region_state-error" className="js-form-error" htmlFor="business_activities_region_state">
                          {formik.errors.business_activities_region_state}
                        </label>
                      ) : null}
                      <label className="c-quote__label" htmlFor="">
                    
                        <p>
                          {lang === 'eng' ? 
                    'Please indicate all the ports of entry used. If you enter through multiple states, choose the specific ports from the list provided below.' : 'Por favor, Indique todos los puertos de entrada utilizados. Si entra por varios estados, elija los puertos específicos de la lista que figura a continuación.'}
                        </p>
                      </label>

                    </div>

                    {/* Port entries */}
                    <div className="c-quote__item c-quote__error">
                      <div className="c-quote__label" htmlFor="">
                        {lang === 'eng' ? 'List of port entries' : 'Listado de puertos de entrada'}
                      </div>
                      <div className="c-quote__box">
                        <ul className="o-list-bare c-quote__box__list">
                          {portItems.map((item) => (
                            <li className="o-list-bare__item" key={item.id}>
                              {item.text}
                              <button type="button" onClick={() => handleSelfRemove(item.id)}>
                                <span className="o-icon">
                                  <svg aria-hidden="true" focusable="false" role="img">
                                    <use href="images/icons/icons.svg#icon-cancel" />
                                  </svg>
                                </span>
                              </button>
                            </li>
                          ))}

                        </ul>
                        <div className="o-list-bare__item btn-add">
                          {!isEditing ? (
                         <button type="button" onClick={() =>  setIsEditing(true)}>
                         {lang === 'eng' ? 'Please indicate all the ports of entry used' : 'Agregar más puertos de entrada'}
                       </button>
                          ) : (
                            <Select
                              ref={selectRef}
                             // className="js-valid-select"
                              id="port_selection"
                              name="port_selection"
                              options={availablePortOptions}
                              placeholder={lang === 'eng' ? 'Add more port entries ...' : 'Agregar más puertos de entrada... '}
                              value={selectedValue}
                              menuIsOpen={isEditing}
                              styles={selectStyles}
                              //className="  css-eo85ql-menu css-qr46ko css-ykpc8b-option "
                              onChange={(selectedOption) => {
                                if (selectedOption) {
                                  handlePortSelection(selectedOption.value);
                                }
                                setIsEditing(true);
                              }}
                            onBlur={() => setIsEditing(false)}
                             
                          
                              components={{
                                DropdownIndicator: null,
                                IndicatorSeparator: null,
                              }}
                              noOptionsMessage={() => (lang === 'eng' ? 'No options' : 'Sin opciones')}

                            />


                          ) }
                        </div>
 

                      </div>

                    </div>
                    {/* Cities entries */}
                    <div className="c-quote__item">
                      <div className="c-quote__label" htmlFor="">
                        {lang === 'eng' ? 'Cities visited in USA' : 'Ciudades visitadas en USA'}
                      </div>
                      <div className="c-quote__box">
                        <ul className="o-list-bare c-quote__box__list">
                          {citiesItems.map((item) => (
                            <li className="o-list-bare__item" key={item.id}>
                              {item.text}
                              <button type="button" onClick={() => handleCitiesRemove(item.id)}>
                                <span className="o-icon">
                                  <svg aria-hidden="true" focusable="false" role="img">
                                    <use href="images/icons/icons.svg#icon-cancel" />
                                  </svg>
                                </span>
                              </button>
                            </li>
                          ))}

                        </ul>
                        <div className="o-list-bare__item btn-add">
                          {!isCitiesEditing ? (
                            <button type="button" onClick={() => setIsCitiesEditing(true)}>
                              {lang === 'eng' ? 'Add more city entries' : 'Agregar más ciudades'}
                            </button>
                          ) : (
                           
                              <input
                                ref={cityNameRef}
                                className="o-list-bare__item btn-add "
                                id="city_name_textarea"
                                name="city_name"
                                maxLength={50}
                                required
                                placeholder={lang === 'eng' ? 'Add a city entry and press enter' : 'Agrega una ciudad y presione enter'}
                                style={{ width: '100%' }}
                                onKeyPress={(event) => {
                                  if (event.key === 'Enter') {
                                    event.preventDefault();
                                    handleCitiesSelection(event.target.value);
                                    event.target.value = ""; // Clear input value after adding
                                  }
                                }}
                                onBlur={() => setIsCitiesEditing(false)}
                                onChange={e => handleOnlyLettersInputChange(e, 'city_name')}
                              ></input>

                            
                          )}
                        </div>
                      </div>
                    </div>


                    {/* Bus entries */}
                    <div className="c-quote__item">
                      <div className="c-quote__label" htmlFor="">
                        {lang === 'eng' ? 'Type of bus company' : 'Tipo de empresa de autobuses'}
                      </div>
                      <div className="c-quote__box">
                        <ul className="o-list-bare c-quote__box__list">
                          {busItems.map((item) => (
                            <li className="o-list-bare__item" key={item.id}>
                            {lang === 'eng' ? item.text : item.textSpa}
                              <button type="button" onClick={() => handleBusRemove(item.id)}>
                                <span className="o-icon">
                                  <svg aria-hidden="true" focusable="false" role="img">
                                    <use href="images/icons/icons.svg#icon-cancel" />
                                  </svg>
                                </span>
                              </button>
                            </li>
                          ))}

                        </ul>
                     
                        <div className="o-list-bare__item btn-add">
                          {!isBusEditing ? (
                            <button type="button" onClick={() => {setIsBusEditing(true); setIsButtonClicked(true);}}>
                              {lang === 'eng' ? 'Add more bus types' : 'Agregar más tipos de autobuses'}
                            </button>
                          ) : (

                            <Select
                              ref={busSelectRef}
                              id="bus_selection"
                              name="bus_selection"
                              options={availableBusOptions}
                              placeholder={lang === 'eng' ? 'Add more bus types ...' : 'Agregar más tipos de autobuses... '}
                              value={selectedBusValue}
                              menuIsOpen={isBusEditing}
                              onChange={(selectedOption) => {
                                if (selectedOption) {
                                  handleBusSelection(selectedOption.value);
                                }
                                setIsBusEditing(true);
                              }}
                              onBlur={() => setIsBusEditing(false)}
                             //. className=' css-eo85ql-menu css-qr46ko css-ykpc8b-option '
                              styles={selectStyles}
                              components={{
                                DropdownIndicator: null,
                                IndicatorSeparator: null,
                              }}
                              
                              getOptionLabel={(option) => lang === 'eng' ? option.label : option.labelEsp}
                              noOptionsMessage={() => (lang === 'eng' ? 'No options' : 'Sin opciones')}

                            />

                          )}
                        </div>
                      </div>
                      {isButtonClicked && busItems.length === 0 ? (
  <label id="port_selection-error" className="js-form-error" htmlFor="port_selection">
    {lang === 'eng' ? "This field is required" : "Este campo es requerido"}
  </label>
) : null}
                    </div>


                    <div className="c-quote__controls">
                      <button
                        className="c-quote__control c-quote__control--previous c-button c-button--linear-indingo"
                        type="button"
                        onClick={backStep}
                      >
                        {lang === 'eng' ? 'Previous' : 'Atrás'}
                      </button>
                      <button
  className="c-quote__control c-quote__control--submit c-button c-button--blue-light"
  type="button"
  onClick={(e) => {
    if (checkifBusItems()) {
      formik.handleSubmit(e);
    }
  }}
>
  {lang === 'eng' ? "Continue" : "Continuar"}
</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer className="c-site-footer">
    <div className="o-wrapper">
      <div className="c-site-footer__legal">
        <p className="c-site-footer__legal_text">
          © 2023 Bluefire Insurance Services Inc.
          <br />
          {lang === 'eng' ? <>List Of Entity/License Numbers Per State Located On  <br/></> : <>Listado de entidades/números de licencia por estado <br /> localizada en nuestra página de</>}  
  <a href="https://www.bluefireinsurance.com/affiliate-disclosure/" target="_blank" rel="noopener noreferrer">
    {lang === 'eng'? "Affiliate Disclosure Page." : " Aviso de Nuestras Filiales"} 
  </a>

        </p>
          <ul className="o-list-bare c-site-footer__legal_links">
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
      { lang=== 'eng' ? ` Privacy Policy` : `Políticas de privacidad`}
    </a>
  </li>
  {window.innerWidth <= 768 && lang !== 'eng' ? (
    <>
      <li className="o-list-bare__item c-site-footer__legal-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del"}
        </a>
      </li>
      <li className="o-list-bare__item c-site-footer__legal-link spanish-consumer-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "" : "Consumidor de California"}
        </a>
      </li>
    </>
  ) : (
    <li className="o-list-bare__item c-site-footer__legal-link ">
      <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
        {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del Consumidor de California"}
      </a>
    </li>
  )}
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
      {lang === 'eng' ? " Terms of Use" : "Condiciones de uso"}
    </a>
  </li>
</ul>
      </div>
    </div>
  </footer>
    </>

  );

}

export default BfFormstep12;
